import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonMatchInformationComponent } from '@/app/components/shared/skeleton/skeleton-match-information/skeleton-match-information.component';
import { CardInfoMatchComponent } from '@/app/pages/sports/football/match-details/components';
import { MatchInformationService } from '@/app/pages/sports/football/match-details/services';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-information',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NoResultComponent,
    SkeletonMatchInformationComponent,
    CardInfoMatchComponent,
  ],
  templateUrl: './information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationComponent {
  private route = inject(ActivatedRoute);
  private matchService = inject(MatchInformationService);
  public urlIMG = environment.urlIMG;

  matchInfoSignal = this.matchService.matchinformation;
  isLoading = this.matchService.isLoadingMatchStats;
  isError = this.matchService.isErrorMatchStats;

  constructor() {
    const matchId = this.route.snapshot.paramMap.get('matchId');
    if (matchId) {
      this.matchService.getMatchInformation(matchId);
    }
  }
}
